import styled from '@emotion/styled';
import { TileWrapper } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTile.styles';
import { COLORS3, MEDIA_QUERY } from '@zola/zola-ui/src/styles/emotion';

import PageWrapper from './PageWrapper.styles';

export const FindACouplePageWrapper = styled(PageWrapper)`
  ${TileWrapper} {
    width: 150px;

    a,
    img {
      width: 150px;
    }

    ${MEDIA_QUERY.TABLET} {
      width: 182px;

      a,
      img {
        width: 182px;
      }
    }

    ${MEDIA_QUERY.DESKTOP} {
      width: 350px;

      a,
      img {
        width: 350px;
      }
    }
  }
`;

export const SearchWrapper = styled.div`
  border-bottom: 1px solid ${COLORS3.BLACK_030};
`;
